import { render } from "./ProductPriceListView.vue?vue&type=template&id=9cd301a8"
import script from "./ProductPriceListView.vue?vue&type=script&lang=js"
export * from "./ProductPriceListView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__